"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.digitalAudiencesQueryComposer = exports.messagesSelector = exports["default"] = void 0;

var _reselect = require("reselect");

var actions = _interopRequireWildcard(require("../actions"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var initialState = {
  isFetching: false,
  firstTab: '',
  quadrant: {
    sumOfValues: 0
  },
  subQuadrants: [],
  persona: {},
  personas: [],
  sections: [],
  threshold: null,
  error: {}
}; // $FlowFixMe

var messageStreams = function messageStreams(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case actions.GET_QUADRANT_MESSAGES_REQUEST:
      return _extends({}, state, {
        isFetching: true
      });

    case actions.GET_QUADRANT_MESSAGES_SUCCESS:
      return _extends({}, state, {
        firstTab: action.payload.sections ? action.payload.sections[0].subsections[0].label : '',
        isFetching: false
      }, action.payload);

    case actions.GET_QUADRANT_MESSAGES_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        threshold: state.threshold,
        error: action.payload
      });

    case actions.SET_INDEX_THRESHOLD:
      return _extends({}, state, {
        threshold: action.payload
      });

    case actions.SET_BRIEFS_FLOW:
      return _extends({}, state, {
        threshold: action.payload === 'find' ? 110 : 0
      });

    default:
      return state;
  }
};

var _default = messageStreams;
exports["default"] = _default;
var messagesSelector = (0, _reselect.createSelector)(function (state) {
  return state.messageStreams;
}, function (state) {
  return state.campaignCreator.briefsFlow;
}, function (messageStreams, briefsFlow) {
  var sections = messageStreams && messageStreams.sections ? messageStreams.sections.reduce(function (messages, section) {
    return [].concat(messages, section.subsections);
  }, []) : []; // generate message to add to persona list

  return {
    sections: sections,
    firstTab: messageStreams.firstTab,
    isFetching: messageStreams.isFetching
  };
});
exports.messagesSelector = messagesSelector;
var digitalAudiencesQueryComposer = (0, _reselect.createSelector)(function (state) {
  return state.messageStreams;
}, function (messageStreams) {
  var personaIds = messageStreams.personas.map(function (persona) {
    return persona.id;
  }).join(',') || [];
  return "?personaIds=" + personaIds;
});
exports.digitalAudiencesQueryComposer = digitalAudiencesQueryComposer;